import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget';
import InsertEmbedCodeCommand from './embed-code-command';
export default class EmbedCodeEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertEmbedCode', new InsertEmbedCodeCommand(this.editor));
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('embedCode', {
            isObject: true,
            allowWhere: '$block',
        });
        schema.register('embedCodeContent', {
            isLimit: true,
            allowIn: 'embedCode',
            allowContentOf: '$block',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.for('upcast').elementToElement({
            model: 'embedCode',
            view: 'x-embed-code',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'embedCode',
            view: 'x-embed-code',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'embedCode',
            view: (modelElement, { writer }) => {
                const div = writer.createContainerElement('div', {
                    class: 'embed-code',
                });
                return toWidget(div, writer, { label: 'Embed code widget' });
            },
        });
        conversion.for('upcast').elementToElement({
            model: 'embedCodeContent',
            view: 'x-embed-code-content',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'embedCodeContent',
            view: 'x-embed-code-content',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'embedCodeContent',
            view: (modelElement, { writer }) => {
                const div = writer.createEditableElement('div', {
                    class: 'embed-code__content',
                });
                return toWidgetEditable(div, writer);
            },
        });
    }
}
